export const loginRules = () => ({
  emailRules: [
    v => !!v || 'Email is required',
    v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
  ],
  passwordRules: [
    v => !!v || 'Password is required',
  ],
})

export const newClientRules = () => ({
  nameRules: [
    v => !!v || 'Name is required',
    v => (v && v.length <= 50) || 'Name must be less than 50 characters',
    v => (v && v.length >= 5) || 'Name must be greater than 5 characters',
  ],

  /* usernameRules: [
            v => !!v || 'Username is required',
            v => (v && v.length <= 15) || 'Username must be less than 15 characters',
        ], */
  /* emailRules: [
            v => !!v || 'Email is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ], */
  /* passwordRules: [
            v => !!v || 'Password is required',
            v => (v && v.length >= 6 && v.length <= 12) || 'Password must be 6-12 alphanumeric characters in length',
        ], */
  /* pinRules: [
            v => !!v || 'PIN is required',
            v => (v && v.length === 4) || 'PIN must be 4 numbers in length',
        ], */
  /* RoleRules: [
            v => !!v || 'Role is required'
        ], */
  /* rateRules: [
            v => !!v || 'Rate is required',
            v => (v && v.length <= 4) || 'Rate must be not longer than 4 numbers in length',
        ], */
  zipRules: [
    v => !!v || 'ZIP is required',
    v => (v && v.length === 5) || 'ZIP must be 5 numbers in length',
  ],
  anyRequired: [
    v => !!v || 'This field is required',
  ],
})

export const reportRules = () => ({
  dateRules: [
    v => !!v || 'Date is required',
  ],
})
